// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__wMYv_","colCheckbox":"styles_colCheckbox__2W8xx"};